var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-text-field", {
    attrs: {
      type: "text",
      id: _vm.id,
      name: _vm.name,
      "data-cy": _vm.name,
      label: _vm.label,
      "error-messages": _vm.errorMessages,
      outlined: _vm.outlined,
      dense: _vm.dense,
      required: _vm.required,
      disabled: _vm.disabled,
      "single-line": _vm.singleLine,
      "hide-details": _vm.hideDetails,
    },
    on: {
      keypress: _vm.numericOnly,
      change: function ($event) {
        return _vm.$emit("change", $event)
      },
    },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }